import { render, staticRenderFns } from "./Presence.vue?vue&type=template&id=8501f6da&scoped=true"
import script from "./Presence.vue?vue&type=script&lang=js"
export * from "./Presence.vue?vue&type=script&lang=js"
import style0 from "./Presence.vue?vue&type=style&index=0&id=8501f6da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8501f6da",
  null
  
)

export default component.exports